import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _Stack;
var _excluded = ["sx"];
import React from 'react';
import { Skeleton, Stack, extendSX } from '@lumahealthhq/ui-core';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var skeletons = Array.from({
  length: 4
}, function (_, index) {
  return index;
});

/**
 * This is the Fallback component to render till the module is ready.
 */
export default function FallbackFormPatientFormJumpLogicVariables(_ref) {
  var sx = _ref.sx,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(Stack, {
    gap: 3,
    sx: {
      overflowY: 'auto',
      marginInline: 'auto',
      // This is to handle the boxShadow of the accordion
      p: '1px'
    },
    children: [_Stack || (_Stack = /*#__PURE__*/_jsxs(Stack, {
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        variant: "text",
        width: 100,
        height: 40
      }), /*#__PURE__*/_jsx(Skeleton, {
        variant: "text",
        width: 170,
        height: 32
      })]
    })), /*#__PURE__*/_jsx(Stack, _extends({
      gap: 3,
      sx: extendSX(sx, {
        overflowY: 'auto',
        width: '100%',
        marginInline: 'auto'
      })
    }, rest, {
      children: skeletons.map(function (it) {
        return /*#__PURE__*/_jsx(Skeleton, {
          variant: "rectangular",
          height: 100
        }, it);
      })
    }))]
  });
}